var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('v-overlay',{attrs:{"value":_vm.isLoading}},[_c('v-card',{attrs:{"color":"white","dark":"","width":"300"}},[_c('v-card-text',{staticClass:"black--text"},[_vm._v(" "+_vm._s(_vm.loadingMessage)+" "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }